
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
    setVideo: { // Set to video tab by default (e.g. when #red-tv in URL)
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      activePostType: null,
      articles: [],
      offset: 0,
      noMorePosts: false,
      loading: false,
      showLoadMore: false,
    };
  },
  computed: {
    config () {
      return this.additionalConfig?.match_centre_config?.match_centre_media;
    },
    injectedArticles () {
      const articles = [...this.articles];
      if (this.config?.enable_dfps) {
        const dfps = this.config.dfps;
        if (dfps) {
          for (const dfp of dfps) {
            if (dfp.position <= articles.length) { // Check against articles + previous DFPs
            // Only display if position is available
              articles.splice(dfp.position - 1, 0, dfp);
            }
          }
        }
      }
      return articles.filter(article => article.id || article.position);
    },
    postTypes () {
      return this.config?.post_types || [`post`, `video`, `gallery`];
    },
    numInitialPosts () {
      return parseInt(this.config?.number_of_posts) || 10;
    },
    postsPerLoad () {
      return parseInt(this.config?.load_more_posts) || 4;
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.setVideo) {
        this.activePostType = `video`;
      } else {
        this.activePostType = this.postTypes;
      }
      this.getMedia();
    });
  },
  methods: {
    async getMedia (firstLoad = true) {
      this.loading = true;

      if (firstLoad) {
        this.articles = [];
        this.offset = 0;
      }

      const queryParams = {
        fields: `id,title,categories,date,image,slug,link,type,acf`,
        posts: {
          post_type: this.activePostType,
          posts_per_page: firstLoad ? this.numInitialPosts : this.postsPerLoad,
          offset: this.offset,
          meta_query: this.taxonomyQuery(this.fixture.id),
          post_status: `publish`,
        },
        options: {
          date_format: `d F Y`,
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.showLoadMore = firstLoad
          ? request.length === this.numInitialPosts
          : request.length === this.postsPerLoad; // If the request returns fewer posts than requested, we've reached the end
        this.offset = parseInt(this.offset + request.length); // Set our offset (for load more)
        this.articles = this.articles.concat(request);
      } else {
        this.noMorePosts = true;
      }
      this.loading = false;
    },
    isArticle (item) {
      return !!item.title && !!item.id; // TODO: Change when DFP is implemented
    },
  },
};
